/**
 * Tab IDs for partition configuration modal.
 */
export enum PartitionConfigurationTabID {
    GENERAL = 0,
    SITE_SETTINGS = 1,
    SYNCHRONISATION = 2,
    ADVANCED = 3,
    COMMUNICATION_STATUS = 4
}

/**
 * Sync environment values used by partition sync settings.
 */
export const PARTITION_SYNC_ENVIRONMENT = {
    NONE: 0,
    TENANT: 1,
    AUTHORISER_SELECT: 2,
    SECURITY_GROUPS: 3
} as const

/**
 * Legacy partition synchronisation type values.
 */
export const PARTITION_SYNC_TYPE = {
    SOFT: '1',
    ONE_TIME_FULL: '2',
    FULL: '3',
    SERVICE_PACK: '4'
} as const

/**
 * Sync options string values used by partition add/change/info APIs.
 */
export const PARTITION_SYNC_OPTION = {
    EXTENSIONS_ENDPOINT: 'Extensions(Endpoint)',
    EXTENSIONS_TRUNKING: 'Extensions(Trunking)',
    AGENTS: 'Agents',
    SUPERVISORS: 'Supervisors'
} as const

export type PartitionSyncOption = (typeof PARTITION_SYNC_OPTION)[keyof typeof PARTITION_SYNC_OPTION]

export const PARTITION_SYNC_OPTIONS: readonly PartitionSyncOption[] = [
    PARTITION_SYNC_OPTION.EXTENSIONS_ENDPOINT,
    PARTITION_SYNC_OPTION.EXTENSIONS_TRUNKING,
    PARTITION_SYNC_OPTION.AGENTS,
    PARTITION_SYNC_OPTION.SUPERVISORS
]
